export enum UserRole {
	ROLE_WEB_ADMIN = 'ROLE_WEB_ADMIN',
	ROLE_WEB_STAFF = 'ROLE_WEB_STAFF',
}
